<template>
  <div id="app">
   分享成功1222222222222222222222222222
  </div>
</template>

<script>
import wxShare from './utlis/wxShare';
import CryptoJS from 'crypto-js';
import axios from 'axios';
export default {
  name: 'App',
  mounted() {
    // 使用 Web Crypto API 生成随机字节
    const array = new Uint8Array(16); // 创建一个长度为16的字节数组
    window.crypto.getRandomValues(array); // 填充数组
    const randomBytes = Array.from(array).map(b => b.toString(16).padStart(2, '0')).join('');
    console.log('Random Bytes:', randomBytes);

    // 示例：使用 crypto-js 创建一个 SHA256 哈希
    const message = 'Hello, world!';
    const hash = CryptoJS.SHA256(message).toString();
    console.log('Hash:', hash);

    const getJsapiTicket = async () => {
      const storedTicket = localStorage.getItem('jsapi_ticket');
      const storedTime = localStorage.getItem('jsapi_ticket_time');
      const currentTime = Math.floor(Date.now() / 1000);
      console.log('currentTime', currentTime);
      console.log('storedTime', storedTime);

      const newTicket = await fetchNewJsapiTicket();
      localStorage.setItem('jsapi_ticket', newTicket);
      localStorage.setItem('jsapi_ticket_time', currentTime.toString());
      return newTicket;
    };

    const fetchNewJsapiTicket = async () => {
      try {
        // // Step 1: 获取 access_token
        const accessTokenResponse = await axios.get('/cgi-bin/token', {
          params: {
            grant_type: 'client_credential',
            appid: 'wx000f6a33b54bfe0d',
            secret: 'fa46ca68c3f45cd215582834047e6870'
          }
        });
        const accessToken = accessTokenResponse.data.access_token;
        // Step 2: 获取 jsapi_ticket
        const jsapiTicketResponse = await axios.get('/cgi-bin/ticket/getticket', {
          params: {
            access_token: accessToken,
            type: 'jsapi'
          }
        });
        console.log('jsapiTicketResponse', jsapiTicketResponse);
        return jsapiTicketResponse.data.ticket;
      } catch (error) {
        console.error('Error fetching jsapi_ticket:', error);
        return null;
      }
    };

    const generateSignature = (jsapi_ticket, nonceStr, timeStamp, url) => {
      const params = {
        jsapi_ticket: jsapi_ticket,
        noncestr: nonceStr,
        timestamp: timeStamp,
        url: url
      };

      const sortedKeys = Object.keys(params).sort();
      const string1 = sortedKeys.map(key => `${key}=${params[key]}`).join('&');
      console.log('String to sign:', string1);
      return CryptoJS.SHA1(string1).toString();
    };
    const initWxConfig = async () => {
      const jsapi_ticket = await getJsapiTicket();
      console.log('jsapi_ticket', jsapi_ticket);
      const url = window.location.href.split('#')[0];
      const timeStamp = Math.floor(Date.now() / 1000).toString();
      const nonceStr = randomBytes;
      console.log('nonceStr', nonceStr);
      console.log('timeStamp', timeStamp);
      console.log('url', url);
      const signature = generateSignature(jsapi_ticket, nonceStr, timeStamp, url);
      console.log('signature', signature);
      const wxConfigData = {
        appId: 'wx000f6a33b54bfe0d',
        timeStamp: timeStamp,
        nonceStr: nonceStr,
        signature: signature
      };
      const shareData = {
        title: '分享标题',
        desc: '分享描述',
        linkurl: 'https://www.baidu.com',
        imgUrl: 'https://tse4-mm.cn.bing.net/th/id/OIP-C.jf5fAnMXNNCBn9bZmcmonQHaHa?rs=1&pid=ImgDetMain'
      };
      wxShare.getJSSDK(wxConfigData, shareData);
    };

    initWxConfig();
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
